import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/teachers/TeachersAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import "../../../../../../_metronic/_assets/sass/pages/wizard/wizard-4.scss";
import KTWizard from "../../../../../../_metronic/_assets/js/components/wizard";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { TeacherEditForm } from "./TeacherEditForm";

export function TeacherEdit({
  history,
  match: {
    params: { id }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, teacher } = useSelector(
    (state) => ({
      actionsLoading: state.teachers.actionsLoading,
      isSuccess: state.teachers.isSuccess,
      type: state.teachers.type,
      teacher: state.teachers.teacher
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getTeacher(id));
    return () => dispatch(actions.cleanTeachersState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Öğretmen";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Belli Bir Öğretmeni Kaydeder
  const saveTeacher = (formData) => {
    dispatch(actions.saveTeacher(formData)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/ogretmenler"), 2500);
  };

  const btnRef = useRef();  
  const saveTeacherClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  // Teacher Form Wizard
  const options = {
    startStep: 1,
    clickableSteps: true
  };

  new KTWizard(document.querySelector("#teacher_form_wizard"), options);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>       
        <TeacherEditForm
          teacher={teacher}
          btnRef={btnRef}
          saveTeacher={saveTeacher}
        />            
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveTeacherClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}